import useForm from '../../../hooks/utility/useForm';
import useAuth from '../../../hooks/global/useAuth';
import CustomerInfoSection from './CustomerInfoSection';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import InvoiceInfoSection from './InvoiceInfoSection';
import { forwardRef, useImperativeHandle } from 'react';
import MarketingSubscriptionSection from './MarketingSubscriptionSection';
import OrderInfoSection from './OrderInfoSection';

export enum SectionType {
  order_method_details = 'order_method_details',
  customer_info = 'customer_info',
  payment_info = 'payment_info',
  invoice_info = 'invoice_info',
  remember_me = 'remember_me',
}

export type CheckoutInfoBagHandle = {
  toggleSection: (section: SectionType, open: boolean) => void;
};

const CheckoutInfoBag = forwardRef<CheckoutInfoBagHandle>((_props, ref: any) => {
  useImperativeHandle(ref, () => ({ toggleSection }));

  const { isGuest } = useAuth();
  const { data, isCustomerInfoComplete } = useOrderFlow();

  const { data: openSections, update: updateSection } = useForm({
    [SectionType.customer_info]: isGuest || !isCustomerInfoComplete,
  });

  function toggleSection(section: SectionType, open: boolean): void {
    updateSection(section, open);
    open &&
      document.getElementById(section)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  }

  return (
    <div className="pt-md space-y-md">
      <OrderInfoSection toggleSection={toggleSection} />
      <CustomerInfoSection show={openSections.customer_info} />
      <MarketingSubscriptionSection />
      {data.total > 0 && <InvoiceInfoSection show />}
    </div>
  );
});

export default CheckoutInfoBag;
